import React, { useState } from "react";
import Select from "react-select";
import { Button, Card, Divider, Flex, List, Space, Typography } from "antd";
import { PlusCircleOutlined } from "@ant-design/icons";
import OptionCheckBox from "@/app/components/OptionCheckBox";
import ExtraOptions from "../../stylists/[id]/components/ExtraOptions";
import ModalCard from "@/app/components/ModalCard";
import CombineServices from "../../stylists/[id]/components/CombineServices";
import { ServiceOption, Service } from "@/lib/api/types";
import { formatMinutes } from "@/lib/helpers";

const { Title, Text } = Typography;

interface ServiceWithOption extends Service {
  option?: ServiceOption;
}

interface ServicesProps {
  showPrice?: boolean;
  defaultServices: Service[];
  selectedServices: ServiceWithOption[];
  setServices: (services: ServiceWithOption[]) => void;
}

const SelectService = ({
  showPrice,
  selectedServices,
  defaultServices,
  setServices,
}: ServicesProps) => {
  const [isOptionModalActive, setOptionModalActive] = useState<
    number | undefined
  >(undefined);
  const [isCustomServiceModalActive, setCustomServiceModalActive] =
    useState(false);

  let totalDuration: number = 0;
  selectedServices.forEach((service) => {
    if (service.duration) {
      if (service.option) {
        totalDuration += service.option.duration;
      } else {
        totalDuration += service.duration;
      }
    }
  });

  const customService: any = {
    _id: "0",
    category: 0,
    title: (
      <div style={{ display: "flex", alignItems: "center" }}>
        <PlusCircleOutlined />
        <span className="ml-1">Custom</span>
      </div>
    ),
  };

  const onCombineServices = (services: ServiceWithOption[]) => {
    setServices(services);
    setCustomServiceModalActive(false);
  };

  const handleOption = (index: number, option?: ServiceOption) => {
    const updatedServices = [...selectedServices];
    updatedServices[index] = {
      ...updatedServices[index],
      option: option ? { ...option } : undefined,
    };
    setServices(updatedServices);
    setOptionModalActive(undefined);
  };
  const renderServiceList = () => (
    <Card size="small">
      <List
        size="small"
        dataSource={selectedServices}
        renderItem={(item, index) => (
          <List.Item
            actions={item.options?.length ? [renderOptionsButton(index)] : []}
          >
            <List.Item.Meta
              title={renderServiceTitle(item)}
              description={item.option && renderServiceOption(item.option)}
            />
          </List.Item>
        )}
      />
      {/* {totalDuration > 0 && (
        <>
          {" "}
          <Divider />
          <div className="has-text-centered">
            <Text>
              Total
              <Divider type="vertical" />
              {formatMinutes(totalDuration)}
            </Text>
          </div>
        </>
      )} */}
    </Card>
  );

  const renderOptionsButton = (index: number) => (
    <Button
      onClick={() => setOptionModalActive(index)}
      type="link"
      size="small"
    >
      options
    </Button>
  );

  const renderServiceTitle = (item: ServiceWithOption) => (
    <>
      <Text>{item.title}</Text>
      {showPrice && !item.option && (
        <>
          <Divider type="vertical" />
          <Text className="is-size-7">${item.price}</Text>
        </>
      )}
    </>
  );

  const renderServiceOption = (option: ServiceOption) => (
    <>
      <Text type="secondary" italic className="is-size-7">
        {option.title}
      </Text>
      {showPrice && (
        <>
          <Divider type="vertical" />
          <Text className="is-size-7">${option.price}</Text>
        </>
      )}
    </>
  );

  return (
    <Space direction="vertical" style={{ width: "100%" }}>
      <header>
        <Flex justify="space-between" align="center">
          <Text strong>
            Services
          </Text>
          {selectedServices.length > 1 && (
            <Button
              onClick={() => setCustomServiceModalActive(true)}
              size="small"
              type="text"
              color="default"
              variant="filled"
            >
              Edit
            </Button>
          )}
        </Flex>
      </header>

      {selectedServices.length > 1 && renderServiceList()}
      {selectedServices.length === 1 && (
        <Space direction="vertical" style={{ width: "100%" }}>
          <Select<{
            title: string;
            category: number;
            data: ServiceWithOption;
          }>
            options={[...defaultServices, customService].map((service) => {
              return {
                title: service.title,
                category: service.category,
                data: service,
              };
            })}
            value={{
              title: selectedServices[0].title,
              category: selectedServices[0].category,
              data: selectedServices[0],
            }}
            getOptionValue={(option) => option.category.toString()}
            getOptionLabel={(option) => option.title}
            onChange={(value) => {
              if (value) {
                value.category === 0
                  ? setCustomServiceModalActive(true)
                  : setServices([{ ...value.data }]);
              }
            }}
            // menuPlacement="top"
          />
          {selectedServices[0].options &&
            selectedServices[0].options.length > 0 && (
              <OptionCheckBox
                showPrice={showPrice}
                option={selectedServices[0].option}
                onOpenOptionModal={() => setOptionModalActive(0)}
                onCancelOption={() => {}}
              />
            )}
        </Space>
      )}
      {isOptionModalActive !== undefined && (
        <ExtraOptions
          service={selectedServices[isOptionModalActive]}
          showPrice={showPrice}
          onSubmit={(option) => handleOption(isOptionModalActive, option)}
          onClose={() => setOptionModalActive(undefined)}
        />
      )}
      {isCustomServiceModalActive && (
        <ModalCard
          title="Build Services"
          onClose={() => setCustomServiceModalActive(false)}
        >
          <CombineServices
            services={defaultServices}
            selectedServices={selectedServices}
            showPrice={showPrice}
            onSubmit={onCombineServices}
          />
        </ModalCard>
      )}
    </Space>
  );
};

export default SelectService;
